<template>
  <div id="users">
    <!-- Users Filter -->
    <b-form-input
      type="text"
      ref="filterUsers"
      placeholder="Filter Organizers"
      v-model="filter">
    </b-form-input>
    <!-- / Users Filter -->

    <!-- Users Table -->
    <b-table
      striped
      hover
      selectable
      small
      show-empty
      stacked="lg"
      select-mode="single"
      sort-by="name"
      @row-selected="goToUser"
      :items="users"
      :fields="fields"
      empty-text="No Users to show.">
    </b-table>
    <!-- / Users Table -->

    <!-- Create Users Button -->
    <b-button
      class="corner-button shadow"
      type="button"
      variant="success"
      @click="$router.push({ name: 'organizer', params: { userID: 'new' } })">
      <font-awesome-icon icon="plus"></font-awesome-icon> Create New User
    </b-button>
    <!-- / Create Users Button -->
  </div>
</template>

<script>
import _ from 'lodash';
import AppMixin from '../services/app-mixin';
import DataSvc from '../services/data';

export default {
  name: 'users',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      filter: '',
      users: [],
      debouncedLoadUsers: null,
      fields: [
        {
          key: 'last_name',
          sortable: true,
        },
        {
          key: 'first_name',
          sortable: true,
        },
        {
          key: 'organization',
          label: 'Organization',
          sortable: true,
        },
        {
          key: 'email',
          sortable: true,
        },
        {
          key: 'primary_phone',
          label: 'Phone',
          sortable: true,
        },
      ],
    };
  },
  watch: {
    filter() {
      this.debouncedLoadUsers();
    },
  },
  methods: {
    goToUser(selected) {
      const [o] = selected;
      this.$router.push({
        name: 'organizer',
        params: { userID: o.id },
      });
    },
    getOrg(id) {
      const org = _.find(this.organizations, { id }) || {};
      return org.name;
    },
    loadUsers() {
      return DataSvc.getOrganizers(this.filter)
        .then((users) => {
          this.users = users;

          _.each(this.users, (user) => {
            let org = _.find(this.organizations, { id: user.admin_organization_id });

            if (org) {
              org = org.name;
            }

            user.organization = org;
          });
        });
    },
  },
  created() {
    this.debouncedLoadUsers = _.debounce(this.loadUsers, 300);

    this.showGlobalLoader('Loading users...');
    this.initPromise
      .then(() => this.loadUsers())
      .finally(this.hideGlobalLoader);
  },
  beforeDestroy() {
    if (this.debouncedLoadUsers && this.debouncedLoadUsers.cancel) {
      this.debouncedLoadUsers.cancel();
    }
  },
};
</script>

<style lang="scss"></style>
